import lodash from 'lodash';

import type { TextStyle as TextStyleRichContent } from './../../ricos-schema/legacy/wix/rich_content/v1/index.js';
import type { CustomTextualStyle } from './../../ricos-types/index.js';

type TextStyleWithoutAlignment = Omit<TextStyleRichContent, 'textAlignment'>;

export class RicosTextStyle {
  textStyle: TextStyleWithoutAlignment;

  private constructor(textStyle: TextStyleWithoutAlignment) {
    this.textStyle = this.preprocess(textStyle);
  }

  private preprocess(textStyle: TextStyleWithoutAlignment) {
    let lineHeight = textStyle.lineHeight;
    if (lineHeight && !Number(lineHeight)) {
      if (lineHeight.includes('px') || lineHeight.includes('em')) {
        lineHeight = lineHeight.slice(0, lineHeight.length - 2);
      }
    }
    return lodash.pickBy({ ...textStyle, lineHeight });
  }

  static of(textStyle: TextStyleWithoutAlignment): RicosTextStyle {
    return new RicosTextStyle(textStyle || {});
  }

  getTextStyle = (): TextStyleWithoutAlignment => this.textStyle;

  static fromCustomStyle = (customStyle: CustomTextualStyle): RicosTextStyle => {
    const { lineHeight } = customStyle;
    const textStyle = { lineHeight } as TextStyleRichContent;
    return RicosTextStyle.of(textStyle);
  };

  toCustomStyle = (): CustomTextualStyle => {
    return { lineHeight: this.textStyle.lineHeight };
  };

  overrideWith = (textStyle: TextStyleWithoutAlignment): RicosTextStyle => {
    return RicosTextStyle.of({ ...this.textStyle, ...textStyle });
  };
}
